import type { Dayjs } from 'dayjs';
import { formatMexicoCityDate } from './mexicoCityDate';

export const formateDatetoPetitionHHmm = (date: string): string => {
  //Recives `HH:mm:ss`
  //Return  date on `HH:mm:ssZ`
  return date + 'Z';
};
export const removeZOnHourtoDisplay = (hour: string): string => {
  //Recives  'HH:mm:ssZ'
  const temp = hour.split(':');
  return `${temp[0]}:${temp[1]}`;
};

export const dateForDisplay = (dateISO: string, onlyDate?: boolean): string => {
  const date = /^\d{4}-\d{2}-\d{2}$/.test(dateISO)
    ? new Date(`${dateISO}T12:00:00.000Z`)
    : new Date(dateISO);

  return formatMexicoCityDate(
    date,
    onlyDate ? 'dd/MMMM/yyyy' : 'dd/MMMM/yyyy HH:mm:ss'
  );
};

export const formatScheduleIntervalDate = (dayjsDate: Dayjs) => {
  const localDate = formatMexicoCityDate(dayjsDate.toDate(), 'HH:mm:ss');
  const timeFormat = formateDatetoPetitionHHmm(localDate);
  return timeFormat;
};
